import React from "react";
import styled from "styled-components";
import filter from "../../../assets/filter.png";
import concessionWhite from "../../../assets/concessionWhite.png";
import SearchBar from "../../common/Search/SearchBar";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #FFFEF9;
  border-bottom: 1px solid #ddd;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const TextAndButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  background-color: #6AB8A8;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;

  img {
    margin-left: 10px;
    width: 20px;
    height: 20px;
  }

  span {
    font-size: 18px;
    margin-left: 10px;
  }
`;

const WelcomeText = styled.div`
  font-size: 18px;
  color: #002E3B;
  font-weight: 600;
  margin-left: 25px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const CadastrarVagasText = styled.div`
  font-size: 18px; 
  color: #FF9F1F;
  font-weight: bold;
  margin-left: 0px;
`;

const SearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 37px;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 10px;
  }
`;

const BemVindoWrapper = styled.div`
  @media (max-width: 768px) {
    padding-top: 50px;
  }
`;

const ConcessoesHeader = ({ user, onSortChange, searchValue = '', onSearchChange, title = 'Todas as Concessões' }) => {
  return (
    <BemVindoWrapper>
      <Container>
        <TextAndButtons>
          <WelcomeText>CONCESSÃO / VALIDAÇÕES</WelcomeText>
          <img src={concessionWhite} alt="Concessões" style={{ marginLeft: "0px", width: "40px", height: "40px", marginTop: "5px" }} />
          <CadastrarVagasText>{title}</CadastrarVagasText>
          <Button>
            Filtrar
            <img src={filter} alt="Filtrar" />
          </Button>
          <Button
            type="button"
            onClick={() => onSortChange?.((current) => current === "asc" ? "desc" : "asc")}
            title="Ordenar por status"
          >
            Ordenar
            <span className="material-symbols-outlined" style={{ width: "20px", height: "20px", fontSize: "20px" }}>toc</span>
          </Button>
        </TextAndButtons>
        <SearchBarWrapper>
          <SearchBar 
            placeholder="Pesquisar por nome"
            value={searchValue}
            onChange={(event) => onSearchChange?.(event.target.value)}
          />
        </SearchBarWrapper>
      </Container>
    </BemVindoWrapper>
  );
};

export default ConcessoesHeader;

